/**
 * @generated SignedSource<<a3291fb4535e38acb21bfaa267a6445f>>
 * @relayHash a36706bcb128501a5933a98fbda08020
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 87254643fc40b244325fdfa97a4b56bc6ccf22622fadff5eb337608fbb01d85b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ContentOwnershipCheckRestrictionsQuery$variables = {
  accountId: string;
  contentId: string;
};
export type ContentOwnershipCheckRestrictionsQuery$data = {
  readonly userWithContentRestrictions: {
    readonly accountId: string | null | undefined;
    readonly hasSpaceEditPermission: boolean | null | undefined;
    readonly hasSpaceViewPermission: boolean | null | undefined;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly restrictingContent: {
      readonly id: string | null | undefined;
      readonly links: {
        readonly base: string | null | undefined;
        readonly webui: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ContentOwnershipCheckRestrictionsQuery = {
  response: ContentOwnershipCheckRestrictionsQuery$data;
  variables: ContentOwnershipCheckRestrictionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "UserWithRestrictions",
    "kind": "LinkedField",
    "name": "userWithContentRestrictions",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "accountId"
      },
      {
        "kind": "ScalarField",
        "name": "hasSpaceEditPermission"
      },
      {
        "kind": "ScalarField",
        "name": "hasSpaceViewPermission"
      },
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "restrictingContent",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "webui"
              },
              {
                "kind": "ScalarField",
                "name": "base"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "operation"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ContentOwnershipCheckRestrictionsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentOwnershipCheckRestrictionsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a36706bcb128501a5933a98fbda08020",
    "id": "87254643fc40b244325fdfa97a4b56bc6ccf22622fadff5eb337608fbb01d85b",
    "metadata": {},
    "name": "ContentOwnershipCheckRestrictionsQuery",
    "operationKind": "query",
    "text": "query ContentOwnershipCheckRestrictionsQuery($accountId:String!,$contentId:ID!){userWithContentRestrictions(accountId:$accountId,contentId:$contentId){accountId,hasSpaceEditPermission,hasSpaceViewPermission,restrictingContent{id,links{webui,base}},operations{operation}}}"
  }
};
})();

(node as any).hash = "ee48824a057953005fb24fb90907119a";

export default node;
